import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import QuillEditorActions from './quillEditorActions';
import QuillToolbar from './quillToolbar';
import styles from '../styles/quill.module.scss';

const QuillEditor = React.forwardRef(({
  editorClass,
  inputClass,
  toolbarClass,
  actionsClass,
  size,
  fileUploadAriaLabel,
  emojiPickerPosition,
  shouldAllowUploads,
  shouldAllowEmojis,
  shouldShowSubmitButton,
  onPaste,
  onCompositionEnd,
  onUploadClicked,
  onEmojiSelected,
  onSubmitClicked,
  id,
  shouldShowEmojiButton,
  shouldShowToolbar,
}, ref) => (
  <div className={classnames(styles.element, editorClass)}>
    <div className={styles.section}>
      {shouldShowToolbar && (
        <QuillToolbar
          ref={ref.toolbar}
          fileUploadAriaLabel={fileUploadAriaLabel}
          className={toolbarClass}
          onEmojiSelect={onEmojiSelected}
          onFileUploadClick={onUploadClicked}
        />
      )}
      <div
        className={classnames(styles.input, inputClass, { [styles.isSizeLarge]: size === 'large' })}
        id={id}
        onPaste={onPaste}
        ref={ref.quill}
        onCompositionEnd={onCompositionEnd}
      />
    </div>
    <QuillEditorActions
      className={actionsClass}
      emojiPickerPosition={emojiPickerPosition}
      shouldAllowUploads={shouldAllowUploads}
      shouldAllowEmojis={shouldAllowEmojis}
      shouldShowSubmitButton={shouldShowSubmitButton}
      onUploadClicked={onUploadClicked}
      onEmojiSelected={onEmojiSelected}
      onSubmitClicked={onSubmitClicked}
      shouldShowEmojiButton={shouldShowEmojiButton}
      fileUploadAriaLabel={fileUploadAriaLabel}
    />
  </div>
));

QuillEditor.defaultProps = {
  id: null,
  editorClass: '',
  inputClass: '',
  toolbarClass: '',
  actionsClass: '',
  size: 'default',
  emojiPickerPosition: 'bottom',
  shouldAllowUploads: true,
  shouldAllowEmojis: true,
  shouldShowSubmitButton: true,
  onPaste: () => {},
  onCompositionEnd: () => {},
  onUploadClicked: () => {},
  onEmojiSelected: () => {},
  onSubmitClicked: () => {},
  shouldShowEmojiButton: true,
  shouldShowToolbar: false,
};

QuillEditor.propTypes = {
  id: PropTypes.string,
  editorClass: PropTypes.string,
  size: PropTypes.string,
  inputClass: PropTypes.string,
  toolbarClass: PropTypes.string,
  actionsClass: PropTypes.string,
  emojiPickerPosition: PropTypes.string,
  shouldAllowUploads: PropTypes.bool,
  shouldAllowEmojis: PropTypes.bool,
  shouldShowSubmitButton: PropTypes.bool,
  onPaste: PropTypes.func,
  onCompositionEnd: PropTypes.func,
  onUploadClicked: PropTypes.func,
  onEmojiSelected: PropTypes.func,
  onSubmitClicked: PropTypes.func,
  shouldShowEmojiButton: PropTypes.bool,
  shouldShowToolbar: PropTypes.bool,
};

export default QuillEditor;
